/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs */

const en_cv_extract_form_enum_engineering_and_technology24 = /** @type {(inputs: Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering and Technology`)
};

const de_cv_extract_form_enum_engineering_and_technology24 = /** @type {(inputs: Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingenieurwesen und Technologie`)
};

/**
* | output |
* | --- |
* | "Engineering and Technology" |
*
* @param {Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const cv_extract_form_enum_engineering_and_technology24 = /** @type {((inputs?: Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cv_Extract_Form_Enum_Engineering_And_Technology24Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cv_extract_form_enum_engineering_and_technology24(inputs)
	return en_cv_extract_form_enum_engineering_and_technology24(inputs)
});
export { cv_extract_form_enum_engineering_and_technology24 as "cv_extract_form_enum_ENGINEERING_AND_TECHNOLOGY" }